import React, { useEffect, useRef } from "react";
import { partial } from "ramda";
import { initGoogleAutocomplete } from "helpers/address";
import { withTracking } from "helpers/analytics";
import { handleErrors } from "helpers/credit_cards";
import { getTargetValue } from "helpers/event";
import Input from "components/input";
var CreditCardAddressAutocomplete = function (_a) {
    var autofocusRef = _a.autofocusRef, newCreditCard = _a.newCreditCard, onBlurValidateField = _a.onBlurValidateField, onNewCreditCardUpdate = _a.onNewCreditCardUpdate;
    var inputRef = useRef(null);
    useEffect(function () {
        var input = inputRef.current;
        if (!input)
            return;
        var onAddressSelected = function (_a) {
            var address = _a.address;
            var _b;
            // Update credit card address fields, via redux.
            onNewCreditCardUpdate({
                address1: address.line1,
                city: address.city,
                state: address.state,
                zip: address.zip,
            });
            // Update value of autocomplete field to contain only line 1 of address.
            input.value = address.line1;
            // Autofocus line 2 instead of removing focus altogether.
            (_b = autofocusRef === null || autofocusRef === void 0 ? void 0 : autofocusRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        initGoogleAutocomplete({ input: input, onAddressSelected: onAddressSelected });
    }, []);
    var handleBlur = withTracking(partial(onBlurValidateField, ["address1", newCreditCard]), "OLO - Checkout - enter billing address");
    var handleChange = function (event) {
        onNewCreditCardUpdate({ address1: getTargetValue(event) });
    };
    var handleError = handleErrors("address1", newCreditCard);
    var inputId = "credit-card-address-1";
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { htmlFor: inputId }, "Address 1"),
        React.createElement(Input, { error: handleError, id: inputId, onBlur: handleBlur, onChange: handleChange, placeholder: "Street and number", ref: inputRef, required: true, type: "text", value: newCreditCard.address1 })));
};
export default CreditCardAddressAutocomplete;
